import { Link } from "react-router-dom";
import { Button } from "@/components/uiDir/button";
import { ArrowRight, Sparkles } from "lucide-react";
import { useState, useEffect } from "react";

const Hero = () => {
const [glitchActive, setGlitchActive] = useState(true);

  useEffect(() => {
    const glitchInterval = setInterval(() => {
      setGlitchActive(true);
      setTimeout(() => setGlitchActive(false), 1000); // Glitch duration
    }, 2000); // Glitch every 3 seconds

    return () => clearInterval(glitchInterval);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 sm:pt-24 bg-[hsl(198,100%,15%)] px-4 sm:px-6">
      {/* Animated Background Pattern - Tech Grid */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `
            linear-gradient(90deg, hsl(198, 50%, 30%) 1px, transparent 1px),
            linear-gradient(0deg, hsl(198, 50%, 30%) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px',
          animation: 'slideDown 20s linear infinite'
        }} />
      </div>

      {/* Floating Geometric Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 border-2 border-[hsl(198,50%,44%)]/30 rotate-45 animate-float" />
        <div className="absolute bottom-1/3 right-1/4 w-48 h-48 border-2 border-[hsl(198,50%,44%)]/30 animate-float" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 right-1/3 w-24 h-24 border-2 border-[hsl(198,50%,44%)]/30 rotate-12 animate-float" style={{ animationDelay: '4s' }} />
      </div>

      {/* Glowing Orbs */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[hsl(198,85%,55%)]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[hsl(198,50%,44%)]/10 rounded-full blur-3xl" />
      </div>

      {/* CIIT Logo */}
      {/* <div className="absolute top-24 left-1/2 transform -translate-x-1/2 z-20">
        <div className="text-white font-bold text-sm tracking-wider">
          <span className="text-2xl">CIIT</span>
          <span className="ml-2 text-xs opacity-80">College of Arts and Technology</span>
        </div>
      </div> */}

      {/* Content */}
      <div className="container relative z-10 mx-auto px-0 py-16 sm:py-20 text-center">
        <div className="max-w-4xl mx-auto animate-fade-in">
          {/* Badge */}
        <div className="inline-flex items-center gap-2 mb-8">
  <span className="text-white/40 text-sm">[</span>
  <span className="text-sm tracking-wide text-white/90">Built for CIITizens</span>
  <span className="text-white/40 text-sm">]</span>
</div>

         {/* Main Heading with Glitch Effect */}
          <div className="relative mb-6">
            <h1 className="font-heading text-4xl sm:text-5xl md:text-7xl font-bold leading-tight text-white">
              <span className={`relative inline-block ${glitchActive ? 'glitch-text' : ''}`}>
                <span className="glitch-main">Your Portfolio,{" "}</span>
                <span className="glitch-layer-2" aria-hidden="true">Your Portfolio,{" "}</span>
                <span className="glitch-layer-1" aria-hidden="true">Your Portfolio,{" "}</span>
              </span>
              <span className={`relative inline-block ${glitchActive ? 'glitch-text' : ''}`}>
                <span className="glitch-main">One Tap Away</span>
                <span className="glitch-layer-1" aria-hidden="true">One Tap Away</span>
                <span className="glitch-layer-2" aria-hidden="true">One Tap Away</span>
              </span>
            </h1>
          </div>

          {/* Subheading */}
          <p className="text-lg sm:text-xl md:text-2xl text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            Create a stunning portfolio and share it instantly with NFC or QR codes. 
            No apps, no friction just your best work, always ready to impress.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 w-full max-w-2xl mx-auto">
            <Link to="/signup">
              <Button 
                className="bg-white text-[hsl(198,100%,15%)] hover:bg-white/90 text-base px-8 h-12 font-semibold transition-all hover:scale-105 w-full sm:w-auto justify-center"
                size="lg"
              >
                Create Your Portfolio
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
            <Link to="/#how-it-works">
              <Button 
                variant="outline" 
                size="lg" 
                className="text-base px-8 h-12 border-white/30 text-blue hover:bg-white/10 hover:border-white/50 w-full sm:w-auto justify-center"
              >
                See How It Works
              </Button>
            </Link>
          </div>

          {/* Stats - Glitch Tower Style */}
          {/* <div className="grid grid-cols-3 gap-8 max-w-2xl mx-auto pt-8 border-t border-white/20">
            <div className="glass-stat-card animate-slide-up" style={{ animationDelay: '0.2s' }}>
              <div className="text-3xl font-bold font-heading text-white mb-1">
                500+
              </div>
              <div className="text-sm text-white/70">Active Portfolios</div>
              <div className="stat-accent bg-[hsl(38,92%,55%)]" />
            </div>
            <div className="glass-stat-card animate-slide-up" style={{ animationDelay: '0.4s' }}>
              <div className="text-3xl font-bold font-heading text-white mb-1">
                10K+
              </div>
              <div className="text-sm text-white/70">Portfolio Views</div>
              <div className="stat-accent bg-[hsl(152,60%,45%)]" />
            </div>
            <div className="glass-stat-card animate-slide-up" style={{ animationDelay: '0.6s' }}>
              <div className="text-3xl font-bold font-heading text-white mb-1">
                4
              </div>
              <div className="text-sm text-white/70">Programs Supported</div>
              <div className="stat-accent bg-[hsl(198,85%,55%)]" />
            </div>
          </div> */}
        </div>
      </div>

      <style >{`
        @keyframes slideDown {
          0% {
            transform: translateY(0);
          }
          100% {
            transform: translateY(60px);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(5deg);
          }
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

     /* Glitch Effect */
        .glitch-text {
          position: relative;
          display: inline-block;
        }

        .glitch-main {
          position: relative;
          z-index: 3;
        }

        .glitch-layer-1,
        .glitch-layer-2 {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0.8;
        }

        .glitch-text .glitch-layer-1 {
          color: hsl(38, 92%, 55%);
          animation: glitch-1 0.2s linear;
          z-index: 2;
        }

        .glitch-text .glitch-layer-2 {
          color: hsl(152, 60%, 45%);
          animation: glitch-2 0.2s linear;
          z-index: 1;
        }

        @keyframes glitch-1 {
          0% {
            transform: translate(0);
          }
          20% {
            transform: translate(-3px, 3px);
          }
          40% {
            transform: translate(-3px, -3px);
          }
          60% {
            transform: translate(3px, 3px);
          }
          80% {
            transform: translate(3px, -3px);
          }
          100% {
            transform: translate(0);
          }
        }

        @keyframes glitch-2 {
          0% {
            transform: translate(0);
          }
          20% {
            transform: translate(3px, -3px);
          }
          40% {
            transform: translate(3px, 3px);
          }
          60% {
            transform: translate(-3px, -3px);
          }
          80% {
            transform: translate(-3px, 3px);
          }
          100% {
            transform: translate(0);
          }
        }

        /* Glass Stat Cards */
        .glass-stat-card {
          position: relative;
          padding: 1.5rem 1rem;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 0.75rem;
          transition: all 0.3s ease;
          overflow: hidden;
        }

        .glass-stat-card:hover {
          background: rgba(255, 255, 255, 0.08);
          transform: translateY(-2px);
        }

        .stat-accent {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 3px;
          opacity: 0.8;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-fade-in {
          animation: fadeIn 0.6s ease-out forwards;
        }

        .animate-slide-up {
          animation: slideUp 0.6s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default Hero;